import { render, staticRenderFns } from "./room-product.vue?vue&type=template&id=480cfa6e&scoped=true&"
import script from "./room-product.vue?vue&type=script&lang=js&"
export * from "./room-product.vue?vue&type=script&lang=js&"
import style0 from "./room-product.vue?vue&type=style&index=0&id=480cfa6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cfa6e",
  null
  
)

export default component.exports